export default {"src":"/_next/static/media/proInCircle.5650d99b.svg","height":100,"width":100};